module.exports = __webpack_public_path__ + "static/thanos2-650a93274d9e8216275c1cb6aaa07593.jpg";